module.exports = __webpack_public_path__ + "img/services_bg.c85ae152.jpg";